"use strict";

module.exports = function(context) {
	return window.JSON.stringify(context);
};



// WEBPACK FOOTER //
// ./client/js/libs/handlebars/tojson.js